import api from 'api';
import { WEB_API_ROUTES } from 'api/api-routes';
import { apiWrapper } from '../../api/apiWrapper';
import { createThunk } from '../../utils/store-utils';

export const thunks = {
  getClassMedia: createThunk('media/getClassMedia', (classroomId) =>
    api.get(WEB_API_ROUTES.media.classroom, {
      params: {
        id: classroomId,
      },
    })
  ),

  getRoutinesMedia: createThunk('media/getRoutinesMedia', (classroomId) =>
    api.get(WEB_API_ROUTES.media.routines, {
      params: {
        id: classroomId,
      },
    })
  ),

  getMedia: createThunk('media/getMedia', ({ params }) =>
    apiWrapper.get(WEB_API_ROUTES.media.mediaMain, {
      params,
    })
  ),

  getMediaById: createThunk('media/getMediaById', (mediaId) =>
    apiWrapper.get(WEB_API_ROUTES.media.mediaById.replace('{mediaId}', mediaId))
  ),
};
